import {
    defaultTemplate,
    partnerstudioTemplate,
    inhouseTemplate,
    sponsorTemplate,
} from './native-templates';

const navigator = global.navigator;

function sendTracking(src) {
    if (navigator.sendBeacon) {
        navigator.sendBeacon(src);
    } else {
        let img = new global.Image();
        const handler = () => {
            img.onload = null;
            img.onerror = null;
            img = null;
        };
        img.onload = handler;
        img.onerror = handler;
        img.src = src;
    }
}

function track(trackers = []) {
    trackers.forEach(sendTracking);
}

class AdNative {
    constructor({ native: nativeObj, ...adObj }) {
        this.adObj = adObj;
        this.nativeObj = nativeObj;
    }

    hasCustomType() {
        return this.nativeObj.custom && this.nativeObj.custom.type;
    }

    getCustomType() {
        if (this.nativeObj.desc2) {
            return this.nativeObj.desc2;
        }

        if (this.hasCustomType()) {
            return this.nativeObj.custom.type;
        }

        return '';
    }

    isContentAd() {
        return this.getCustomType() === 'content';
    }

    isInhouseAd() {
        return this.getCustomType() === 'inhouse';
    }

    isLocalDomain() {
        return this.nativeObj.clickUrl.indexOf('vg.no') > -1;
    }

    attachClickTracker() {
        const link = this.container.querySelector('a');

        link.addEventListener('click', () => {
            track(this.nativeObj.clickTrackers);
        });

        return link;
    }

    createContainer(children) {
        const type = this.getCustomType();
        const typeClass = type ? `ad-native-${type}` : '';
        const container = document.createElement('div');

        const template = `
            <div class="ad-native ${typeClass}">
                ${children}
            </div>
        `.trim();
        container.innerHTML = template;

        return container.firstElementChild;
    }

    getImageRatio() {
        const { image: imageData } = this.nativeObj;

        if (!imageData) {
            return 0;
        }

        const { width, height } = imageData;

        return (height / width) * 100; // eslint-disable-line no-mixed-operators
    }

    setContainerData(key, value) {
        this.container.dataset[key] = value;
    }

    render() {
        let template = '';
        const nativeObj = {
            imageRatio: this.getImageRatio(),
            ...this.nativeObj,
        };

        switch (this.getCustomType()) {
            case 'content':
                template = partnerstudioTemplate(nativeObj);
                break;

            case 'sponsor':
                template = sponsorTemplate(nativeObj);
                break;

            case 'inhouse':
                template = inhouseTemplate(nativeObj);
                break;

            default:
                template = defaultTemplate(nativeObj);
        }

        this.container = this.createContainer(template);

        this.setContainerData('creativeId', this.adObj.creativeId);
        this.attachClickTracker();

        return this.container;
    }
}

export default function nativeRenderer(adObj) {
    return new AdNative(adObj).render();
}



/** WEBPACK FOOTER **
 ** ./src/ads/native.js
 **/